import { defineMessages } from 'react-intl';

export const validationMessages = defineMessages({
    invalidEmailAddress: {
        id: 'validation.invalidEmailAddress',
        description: 'When email invalid',
        defaultMessage: 'Recipient Email must be a valid email address'
    },
    emailAddressRequired: {
        id: 'validation.emailAddressRequired',
        description: 'When email address is missing',
        defaultMessage: 'Email is a required field'
    },
    yourEmailAddressRequired: {
        id: 'validation.yourEmailAddressRequired',
        description: 'When your email address is missing',
        defaultMessage: 'Your Email is a required field'
    },
    senderNameRequired: {
        id: 'validation.senderNameRequired',
        description: 'When sender name missing',
        defaultMessage: 'Sender Name is a required field'
    },
    recipientNameRequired: {
        id: 'validation.recipientNameRequired',
        description: 'When Recipient Name name missing',
        defaultMessage: 'Recipient Name is a required field'
    },
    recipientEmailRequired: {
        id: 'validation.recipientEmailRequired',
        description: 'When recipient email is missing',
        defaultMessage: 'Recipient Email is a required field'
    },
    yourNameRequired: {
        id: 'validation.yourNameRequired',
        description: 'When Your name is missing',
        defaultMessage: 'Your Name is a required field'
    },
    billingNameRequired: {
        id: 'validation.billingNameRequired',
        description: 'When Name on Card is missing',
        defaultMessage: 'Name on Card is a required field'
    },
    firstNameTooLong: {
        id: 'validation.firstNameTooLong',
        description: 'When first name is too long',
        defaultMessage: 'The first name cannot be longer than {max} characters'
    },
    lastNameTooLong: {
        id: 'validation.lastNameTooLong',
        description: 'When last name is too long',
        defaultMessage: 'The last name cannot be longer than {max} characters'
    },
    fullNameTooLong: {
        id: 'validation.fullNameTooLong',
        description: 'When the full name is too long',
        defaultMessage: 'The full name cannot be longer than {max} characters'
    },
    firstAndLastOnly: {
        id: 'validation.firstAndLastOnly',
        description: 'When full name is not [first last]',
        defaultMessage: 'Name must be in the form "first last"'
    },
    street1TooShort: {
        id: 'validation.street1TooShort',
        description: 'When street 1 is too short',
        defaultMessage: 'The address must be at least {min} characters'
    },
    stateRequired: {
        id: 'validation.stateRequired',
        description: 'When state is missing',
        defaultMessage: 'State is a required field'
    },
    cityRequired: {
        id: 'validation.cityRequired',
        description: 'When missing city',
        defaultMessage: 'City is a required field'
    },
    invalidPostalCode: {
        id: 'validation.invalidPostalCode',
        description: 'When postal code in invalid',
        defaultMessage: 'Please enter a valid postal code'
    },
    postalCodeRequired: {
        id: 'validation.postalCodeRequired',
        description: 'When postal code is missing',
        defaultMessage: 'ZIP is a required field'
    },
    invalidPhone: {
        id: 'validation.invalidPhone',
        description: 'When phone number in invalid',
        defaultMessage: 'Please enter a valid telephone number'
    },
    phoneRequired: {
        id: 'validation.phoneRequired',
        description: 'When phone number is missing',
        defaultMessage: 'Phone Number is a required field'
    },
    termsAgreement: {
        id: 'validation.termsAgreement',
        description: 'When terms not agreed to',
        defaultMessage: 'You must agree to the terms to continue'
    },
    savedAddressRequired: {
        id: 'validation.savedAddressRequired',
        description: 'Form validation message when no saved address selected',
        defaultMessage: 'You must select an address to continue.'
    },
    addressRequired: {
        id: 'validation.addressRequired',
        description: 'When address is missing',
        defaultMessage: 'Address is a required field'
    },
    fixErrors: {
        id: 'validation.fixErrors',
        description: 'Submit button prompt when form invalid',
        defaultMessage: 'Please fix errors before submitting'
    },
    quantityMax: {
        id: 'validation.quantityMax',
        description: 'When quantity above max',
        defaultMessage: 'Quantity cannot be greater than {max}'
    },
    amountRequired: {
        id: 'validation.amountRequired',
        description: 'When amount is missing',
        defaultMessage: 'Amount is a required field.'
    },
    amountMin: {
        id: 'validation.amountMin',
        description: 'When amount below min',
        defaultMessage: 'Amount must be ${min} or more.'
    },
    amountMax: {
        id: 'validation.amountMax',
        description: 'When amount above max',
        defaultMessage: 'Amount cannot be greater than ${max}.'
    },
    poBoxInvalid: {
        id: 'validation.poBoxInvalid',
        description: 'When street 1 or 2 contains a PO Box',
        defaultMessage: 'We cannot ship to PO boxes. Please enter a physical street address.'
    },
    maxLineItems: {
        id: 'validation.maxLineItems',
        description: 'When max line items in cart',
        defaultMessage: 'You’ve reached the maximum products for a cart.'
    },
    dateBelowMinimum: {
        id: 'validation.dateBelowMinimum',
        description: 'When date is prior to min',
        defaultMessage: 'Delivery Date must be equal to or later than today'
    },
    dateAboveMaximum: {
        id: 'validation.dateAboveMaximum',
        description: 'When date is past max',
        defaultMessage: 'Delivery Date can not be more than a year in the future.'
    },
    dateRequired: {
        id: 'validation.dateRequired',
        description: 'When date is missing',
        defaultMessage: 'Delivery Date is a required field'
    },
    faceplateRequired: {
        id: 'validation.faceplateRequired',
        description: 'When missing faceplate',
        defaultMessage: 'Please select a design'
    },
    canShipValid: {
        id: 'validation.canShipValid',
        description: 'Precheck whether an address can be shipped to or not',
        defaultMessage: 'We’re unable to ship to the specified address. Please use a different address'
    },
    isLoggedInRequired: {
        id: 'validation.isLoggedInRequired',
        description: 'When the user is on a points only mall, and not logged in',
        defaultMessage: 'You must be logged in to purchase cards with points'
    },
    canPurchase: {
        id: 'validation.canPurchase',
        description: 'Does the user have enough points to purchase gift cards.',
        defaultMessage: 'Your order cannot be completed due to insufficient points'
    }
});
